import { getKnownContentOriginSlug } from '@/helpers/billingSourceBook'
import { storage } from '@/helpers/storage'
import { StorageKeys } from '@/helpers/storage.keys'
import type { QuestionnaireView } from '@/models/onboarding'
import type { SampleGuideChoice20710 } from '@/models/onboarding.types'
import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

export async function storeSampleGuide(view: QuestionnaireView): Promise<void> {
  // A saved pick wins over the entry book, including one made while this
  // request is still in flight.
  if (view.userChoices['sample-guide']) {
    return
  }

  const slug = getKnownContentOriginSlug()
  if (!slug) {
    return
  }

  try {
    const { title, url_slug, cover_image, author } = await backend.getBook(slug)
    if (view.userChoices['sample-guide']) {
      return
    }
    const sampleGuide: SampleGuideChoice20710 = {
      title,
      url_slug,
      cover_image,
      author,
    }
    view.userChoices['sample-guide'] = sampleGuide
    storage.setItem(
      StorageKeys.questionnaireChoices,
      JSON.stringify(view.userChoices),
    )
  } catch {
    Sentry.withScope((scope) => {
      scope.setTag('experiment', 'exp_samplefirst_onboarding_v10_20710')
      scope.setExtra('slug', slug)
      Sentry.captureMessage(
        'exp_samplefirst_onboarding_v10_20710: entry book unresolvable',
      )
    })
  }
}
